import { render, staticRenderFns } from "./ActStatus.vue?vue&type=template&id=29af09d0&"
import script from "./ActStatus.vue?vue&type=script&lang=js&"
export * from "./ActStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports